import EventEmitter from 'events'
import helpers from '../helpers'

class Echo extends EventEmitter {
  configure (echo, token, axios, vds) {
    let self = this

    this.echo = echo
    this.token = token
    this.axios = axios
    this.vds = vds

    this._handleEchoEvents()
    this._handleNexusEvents()

    this.connected = false

    // If during the sync nexus already have a token, set it to echo
    if (token.isset()) {
      this._setToken(token)

      this.echo.connector.socket.on('connect', () => {
        self.connect()
      })
    }

    // Run the heartbeat
    setInterval(() => {
      self._heartbeat()
    }, 5 * 60 * 1000)
  }

  connect () {
    let self = this

    if (this.connected) {
      return false
    }

    console.log('[ CHANNEL ] Connecting ...')
    this.echo.connector.connect()

    this.axios.get(helpers.url('api', 'account/users/current'))
      .then((response) => {
        // Subscribing to channels
        try {
          self.vds.driver.listenPrivate(['global', 'user.' + response.data.data.id])
          self.emit('connected')
          self.connected = true
        } catch (err) {
          throw '[ CHANNEL ] Could not connect to the event broadcasting : ' + err
        }
      })
  }

  disconnect () {
    if (!this.connected) {
      return false
    }

    console.log('[ CHANNEL ] Disconnecting ...')

    this.echo.connector.channels = {}
    this.echo.connector.disconnect()

    this.emit('disconnected')

    this.connected = false
  }

  reconnect () {
    this.disconnect()
    this.connect()
  }

  _heartbeat () {
    let self = this

    if (!this.connected) {
      return false
    }

    console.log('[ CHANNEL ] Running Heartbeat ...')

    // Set the timeout function
    let timeout = setTimeout(() => {
      console.log('[ CHANNEL ] Heartbeat failed, trying a reconnect ...')
      self.echo.connector.socket.removeListener('pong', listener)
      this.reconnect() // TODO : Handle if the reconnect fails ?
    }, 1000)

    // Set the pong handler reponse
    let listener = function() {
      console.log('[ CHANNEL ] Heartbeat success !')
      self.echo.connector.socket.removeListener('pong', listener)
      clearTimeout(timeout)
    }

    // Attach the handler and execute the ping
    this.echo.connector.socket.on('pong', listener)
    this.axios.post(helpers.url('api', 'account/channels/ping'))
  }

  _handleEchoEvents () {
    let self = this

    this.echo.connector.socket.on('disconnect', () => {
      self.emit('disconnected')
    })
  }

  _handleNexusEvents () {
    let self = this

    this.token.on('changed', ({token}) => {
      self._setToken(token)

      if (token === null) {
        self.disconnect()
      } else {
        self.reconnect()
      }
    })
  }

  _setToken (token) {
    let self = this

    if (token === null) {
      self.echo.options.auth = {
        headers: {}
      }
    } else {
      self.echo.connector.options.auth = {
        headers: {
          Authorization: 'Bearer ' + self.token.get()
        }
      }
    }
  }
}

export let echo = new Echo()



// WEBPACK FOOTER //
// ./libs/@db2b/nexus-js/vendor/echo.js